import React, { useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { StyledTitles, StyledText } from "./styles";
import Footer from "../components/commons/footer";
import { Link } from "react-router-dom";

function Faq() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);



  return (
    <>
      <Container>
        <Row>
          <Col lg={12} style={{ marginTop: "50px" }}>
            <Link to={"/"} style={{ color: "#000" }}>
              <span
                style={{
                  background: "#E63457",
                  padding: "16px",
                  color: "white",
                  fontWeight: "bold",
                  borderRadius: "3px",
                }}
              >
                Volver
              </span>
            </Link>
          </Col>
        </Row>
        <Row>
          <Col lg={12} style={{ marginTop: "80px" }}>
            <StyledTitles>¿Quiénes somos?</StyledTitles>
            <StyledText>
              
              LatamChequea es una red de chequeadores de toda Latinoamérica,
              Estados Unidos, España y Portugal. Es liderada por Chequeado, de
              Argentina. Comenzó en 2014 y actualmente reúne a 36 organizaciones
              de 17 países donde se habla español o portugés. También incluimos
              organizaciones de Estados Unidos que publiquen notas en español o
              realicen proyectos enfocados en hispanos o latinos. La mayoría de
              los miembros produce contenido en español o portugés, aunque
              también algunos publican en inglés y otros en lenguas originarias
              de su país.
              <br />
              <br /> El objetivo de esta red es compartir experiencias y
              herramientas que contribuyan a mejorar la calidad del debate
              público y fomentar procesos de colaboración entre diversos medios
              de la región para aumentar el impacto del fact checking en nuestro
              continente.
              <br />
              <br /> Son parte distintos medios de fact checking: Chequeado,
              Bolivia Verifica, Chequea Bolivia, Lupa, Estadão Verifica, Aos
              Fatos, Contexto Factual, Mala Espina Check, La Silla Vacía,
              Colombia Check, DeFacto (ElToque), Ecuador Chequea, FactCheck.org,
              El Detector (Univision Noticias), Factchequeado, Maldita, Newtral,
              Agencia Ocote, Verificado, El Sabueso (Animal Político), Escenario
              Tlaxcala, Detrás del discurso, El Surtidor, Ojo Público,
              Verificador (La República), Polígrafo, Salud con Lupa, AFP, EFE
              Verifica, PolétikaRD, Cotejo, Efecto Cocuyo y EsPaja.
              <br />
              <br />
              También hay distintos consorcios de medios, grupos de distintas
              organizaciones que se alían para chequear desinformaciones sobre
              un tema específico como los procesos elecciones, y que participan
              de la red como observadores. Es el caso de: Reverso (Argentina),
              Comprova (Brasil) y Ama Llulla (Perú).
              <br />
              <br />
              Por parte de Chequeado la red es coordinada por Pablo M. Fernández
              (Director Ejecutivo y Periodístico), Laura Zommer (Directora
              General), Olivia Sohr (Directora de Impacto y Nuevas Iniciativas)
              y Martín Slipczuk (Coordinador de Proyectos Especiales).
            </StyledText>
            <StyledTitles>
              ¿Qué tenemos en común todos estos medios?
            </StyledTitles>
            <StyledText>
              LatamChequea es una red de intercambio de prácticas y aprendizajes
              entre medios que hacen chequeo de datos o verificaciones a
              desinformaciones. No tenemos un proceso de revisión ni validación
              formal para ser parte, pero tenemos reglas que los medios u
              organizaciones deben cumplir.
              <br />
              <br /> Entre esos criterios, para participar de la red los medios
              tienen que cumplir un mínimo de 20 chequeos publicados en el
              último año y estos chequeos deben seguir las buenas prácticas
              metodológicas que marca el{" "}
              <a
                href="https://www.ifcncodeofprinciples.poynter.org/"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                Código de Principios{" "}
              </a>{" "}
              de la Red Internacional de Verificación de Hechos (IFCN, por sus
              siglas en inglés), especialmente en lo referente a la
              transparencia de fuentes y de las correcciones. Además, los medios
              deben tener publicado su método y su política de correcciones.
              <br />
              <br /> También, los consorcios de medios que se reúnan para hacer
              fact checking colaborativo se pueden sumar de manera temporal. Los
              líderes de estas alianzas, en caso de que no sean ya parte de la
              red, son invitados a participar como observadores.
              <br />
              <br /> Tanto los consorcios como los medios deben llenar
              anualmente un formulario donde confirman que quieren mantener su
              participación en la red y se evalúa que aún cumplen con los
              requisitos.
              <br />
              <br /> La red LatamChequea colabora activamente con IFCN para
              trabajar de forma complementaria y muchas de las organizaciones de
              LatamChequea forman parte también de IFCN.
            </StyledText>
            <StyledTitles>
              ¿Qué proyectos hacemos y cómo se financia la red?
            </StyledTitles>
            <StyledText>
              La red es coordinada por Chequeado y se financia con fondos de
              Chequeado (ver{" "}
              <a
                href="https://chequeado.com/financiamiento/"
                target="_blank"
                rel="noreferrer"
              >
                acá
              </a>{" "}
              información sobre el financiamiento de la organización). También
              desde Chequeado recaudamos y gestionamos fondos para proyectos
              específicos de organismos internacionales, organizaciones
              filantrópicas y empresas.
              <br />
              <br />
              Desde su nacimiento en 2014 la red organizó{" "}
              <a
                href="https://chequeado.com/proyectos/latamchequea/"
                target="_blank"
                rel="noreferrer"
              >
                eventos presenciales
              </a>
              . Estos contaron con financiamiento de: The Omidyar Group,
              Luminate, Facebook y la Embajada de los Estados Unidos en la
              Argentina.
              <br />
              <br />
              Además, la red desarrolló distintas investigaciones y proyectos
              colaborativos. En el marco de la pandemia en 2020 desarrollamos{" "}
              <a
                href="https://chequeado.com/latamcoronavirus/"
                target="_blank"
                rel="noreferrer"
              >
                LatamChequea Coronavirus
              </a>
              , una base de datos con todas las piezas que desmintieron las
              desinformaciones vinculadas a la pandemia. También creamos en 2021{" "}
              <a
                href="https://chequeado.com/latamchequeavacunas/#/"
                target="_blank"
                rel="noreferrer"
              >
                {" "}
                LatamChequea Vacunas
              </a>
              , otra base que apunta a contrarrestar la desinformación que
              circula sobre las vacunas contra la COVID-19 y donde también
              desarrollamos piezas audiovisuales para difundir por redes
              sociales. En ambos casos contamos con el apoyo de Google News
              Initiative.
              <br />
              <br />
              Publicamos una serie de investigaciones llamada{" "}
              <a
                href="https://chequeado.com/desinformantes/"
                target="_blank"
                rel="noreferrer"
              >
                “Los Desinformantes”
              </a>
              , sobre diferentes actores que han desinformado sistemáticamente
              durante la pandemia. Estas investigaciones pudimos hacerlas
              gracias al apoyo de la Internet Society (ISOC) y de NED.
              <br />
              <br />
              Antes, ya nos habíamos reunido entre nueve medios de la región
              para verificar las desinformaciones más divulgadas sobre la{" "}
              <a
                href="https://elsurti.com/especial/las-mentiras-sobre-la-esi-en-latinoamerica/"
                target="_blank"
                rel="noreferrer"
              >
                educación sexual integral o ESI
              </a>
              .
              <br />
              <br />
              También hemos desarrollado, junto a Unesco y financiado por la
              Unión Europea, un sitio llamado{" "}
              <a
                href="https://portalcheck.org/"
                target="_blank"
                rel="noreferrer"
              >
                PortalCheck
              </a>
              , una iniciativa para presentar recursos útiles sobre cómo
              chequear información y no compartir desinformaciones.
              <br />
              <br />
              Si tenés alguna otra pregunta o querés decirnos algo podés
              escribirnos a{" "}
              <a href="mailto:latamchequea@chequeado.com">
                latamchequea@chequeado.com
              </a>
              .
            </StyledText>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}

export default Faq;
